import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  LoadingIndicator,
} from '@commenda/kakashi';

const SubmitWorkRequestModalKS = ({
  isSubmitting,
  onSubmit,
  description,
}: {
  isSubmitting: boolean;
  onSubmit: () => void;
  description: string;
}) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button>
          <span>Submit</span>
        </Button>
      </DialogTrigger>
      <DialogContent className="bg-white">
        <DialogHeader>
          <DialogTitle>Submit Form</DialogTitle>
        </DialogHeader>
        <p className="body-16-regular text-neutral-3 p-6">{description}</p>
        <DialogFooter>
          <Button
            className="gap-2 min-w-[120px]"
            disabled={isSubmitting}
            onClick={onSubmit}
          >
            {isSubmitting ? (
              <div className="-translate-y-0.5">
                <LoadingIndicator size={16} />
              </div>
            ) : null}
            <span>Submit</span>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SubmitWorkRequestModalKS;
